export default __webpack_public_path__ + "static/media/h_3.357baef6.jpg";